import React from "react";
import "./PoliciesPages.scss";

const Refund = () => {
    return (
        <div className="policy-page">
            <h1>Refund & Cancellation Policy</h1>
            <p>Last updated: January 2025</p>

            <h2>1. General Refund Policy</h2>
            <p>
                Payments for shisha, food, or drink services are non-refundable once
                provided.
            </p>

            <h2>2. Booking Deposits</h2>
            <p>
                Deposits for reservations or events are non-refundable unless Old Kent
                Shisha Lounge cancels the booking.
            </p>

            <h2>3. No-Show Policy</h2>
            <p>No-shows may lose their deposit and reservation time.</p>

            <h2>4. Event Tickets</h2>
            <p>
                Event payments are refundable only if the event is cancelled by Old Kent
                Shisha Lounge.
            </p>
        </div>
    );
};

export default Refund;
